<template>
  <div class="">
    <div class="pb-16">
      <v-card loader-height="2" class="shadow-off" :loading="loading" :disabled="loading">
        <v-card-text class="">
          <div>
            <!-- ApprovalsList handles its own data fetching with pagination (25 items per page) -->
            <ApprovalsList display="edit" @loading="setLoading" :filterData="filterOptionsData"/>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import ApprovalsList from "./components/ApprovalsList.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'varienceanalysis_approvals',
  // props: ['props'],
  data: function(){
    return {
      loading: false,
      // data: [], // Removed redundant data
      // meta: {}, // Removed redundant meta
      viewdialog: false,
      viewloading: false,
      viewdata: {},
      colors: [],
      // filterOptionsData:[] // Removed as it is now a computed property
    }
  },
  components: {
    ApprovalsList
  },
  activated() {
    // this.refreshData();
  },
  created(){
    this.getFilterData()
  },
  mounted() {
    this.colors = this.$nova.getColors(5,0.2);
    // this.refreshData();
  },
  methods: {
    ...mapActions('varianceanalysis/approvals', ['fetchAccessApprovals', 'approveRequest', 'rejectRequest']),

    refreshData() {
      // this.getData() // Removed redundant call
      this.getFilterData(true);
    },
    setLoading(v) {
      this.loading = !!v;
    },
    async getFilterData(forceRefresh = false){
      this.loading = true;
      try {
        await this.fetchAccessApprovals({
          filter: { "filter": { "page": 0, "sync_type": "auto", "type": "approvals" } },
          axiosInstance: this.axios,
          forceRefresh: forceRefresh
        });
      } catch (error) {
         console.error('[Approvals] Error fetching access approvals', error);
      } finally {
        this.loading = false;
      }
    },
    // Redundant getData() removed
    async performApproval(id){
      this.viewloading = true;
      const result = await this.approveRequest({ id, axiosInstance: this.axios });
      if (result && result.success) {
         this.refreshData();
         this.viewdialog = false;
      }
      this.viewloading = false;
    },
    async performRejection(id){
      this.viewloading = true;
      const result = await this.rejectRequest({ id, axiosInstance: this.axios });
      if (result && result.success) {
         this.refreshData();
         this.viewdialog = false;
      }
      this.viewloading = false;
    }
  },
  computed: {
    ...mapGetters('varianceanalysis/approvals', ['getAccessApprovals', 'isLoading']),
    filterOptionsData() {
      // Return cached data or empty array
      return this.getAccessApprovals || [];
    }
  },
  watch: {
  }
}
</script>

<style scoped>
/* .subs-icon{
  background-color: var(--v-primary-base) !important;
  color: white;
} */
</style>
